import {
  DOCUMENT_TYPE_LIST_FAIL,
  DOCUMENT_TYPE_LIST_REQUEST,
  DOCUMENT_TYPE_LIST_SUCCESS,
} from "../constants/documentTypeConstants";

export const documentTypeListReducer = (state = {}, action) => {
  switch (action.type) {
    case DOCUMENT_TYPE_LIST_REQUEST:
      return { loading: true };
    case DOCUMENT_TYPE_LIST_SUCCESS:
      return { loading: false, documentTypes: action.payload };
    case DOCUMENT_TYPE_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
